import React, { useContext } from 'react';

import { EveryActionDonateForm as EveryActionDonateFormComponent } from './EveryActionDonateForm.component';

import { UserContext } from '+/contexts/UserContext';
import { useDoubleTheDonation } from '+/contexts/DoubleTheDonationContext';

const EveryActionDonateForm = props => {
  const userContext = useContext(UserContext);
  const { state: doubleTheDonationState } = useDoubleTheDonation();

  return (
    <EveryActionDonateFormComponent
      {...props}
      userContext={userContext}
      doubleTheDonationState={doubleTheDonationState}
    />
  );
};

export default EveryActionDonateForm;
